import { Button } from "antd";
import React, { useContext } from "react";
import { TrackerContext } from "./utils/types";
const SaveButton: React.FC = () => {
  const {
    trackerLoading,
    startTracking,
    typeOfTracking,
    createSession,
    stopTracking,
    isTracking,
    hasInputError,
  } = useContext(TrackerContext);

  return (
    <>
      {typeOfTracking === "Manual" ? (
        <Button
          type="primary"
          onClick={() => createSession()}
          loading={trackerLoading}
          disabled={isTracking || trackerLoading || hasInputError}
          style={{
            background: "#237804",
            borderColor: "#237804",
            fontWeight: 700,
            borderRadius: "5px",
          }}
        >
          Save
        </Button>
      ) : (
        <>
          {!isTracking ? (
            <Button
              type="primary"
              onClick={() => startTracking()}
              loading={trackerLoading}
              disabled={isTracking || trackerLoading}
              style={{
                borderRadius: "5px",
              }}
            >
              Start
            </Button>
          ) : (
            <Button
              danger
              type="primary"
              onClick={stopTracking}
              loading={trackerLoading}
              disabled={!isTracking || trackerLoading}
              style={{
                borderRadius: "5px",
              }}
            >
              Stop
            </Button>
          )}
        </>
      )}
    </>
  );
};
export default SaveButton;
